var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useI18n } from '@oneaudi/i18n-context';
import { TextButton, Dialog } from '@oneaudi/unified-web-components';
import { useServicesContext } from '../../../../../context';
import { useFinance } from '../FinanceContext';
import { getCurrentProductID } from '../financeModalRethink/form-helperRethink';
import { useRethinkFSCheckoutPostData, fsCheckoutPostRequest, } from '../../../../../utils/fsCheckoutCTA';
import { FinanceCheckoutLayer } from './FinanceCheckout/FinanceCheckoutLayer';
import { dynamicStylingHelper } from '../../../../utils/AlphaHelper';
import { trackDynamicCTAClick } from '../FinanceTracking';
export const FinanceCheckoutPopoverButton = ({ buttonInfo, vehicle, useFinanceData, trackButtonClick, variant, scContextId, isMobileScreenSize, isLoading, isRenderedInConversionBar, IsLayerOpenedFromConversionBar, onClickToCloseFSPopup, selectedModality, }) => {
    var _a;
    const logger = (_a = useServicesContext().getAdditionalService('s2:logger')) !== null && _a !== void 0 ? _a : console;
    const trackingService = useServicesContext().getAdditionalService('audi-tracking-service');
    const { selectedModalityInContext } = useFinance();
    const vehicleType = vehicle === null || vehicle === void 0 ? void 0 : vehicle.type.toLowerCase();
    const currentProductId = getCurrentProductID(useFinanceData, vehicle.type, vehicle.id);
    const productId = currentProductId;
    const modality = (selectedModalityInContext === null || selectedModalityInContext === void 0 ? void 0 : selectedModalityInContext.toLowerCase()) || (selectedModality === null || selectedModality === void 0 ? void 0 : selectedModality.toLowerCase());
    const modifiedProductID = modality !== 'cash' ? productId : modality;
    const financeCheckoutTranslations = {
        financeCheckoutAriaBtn: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.financeCheckoutAriaBtn`,
        }),
        financeCheckoutOuterLayer: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.outer.financeCheckoutLayer.ariaLabel`,
        }),
        financeCheckoutInnerLayer: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.inner.financeCheckoutLayer.ariaLabel`,
        }),
        financeCheckoutAriaCloseBtn: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.inner.financeCheckoutLayer.closeButtonAriaLabel`,
        }),
    };
    const [isApiInprogress, setIsApiInprogress] = useState(false);
    const [IsOpenedFromConversionBar, setIsOpenedFromConversionBar] = useState(IsLayerOpenedFromConversionBar);
    const [fsCheckoutLink, setFsCheckoutLink] = useState(buttonInfo.notFoundPageUrl);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    useEffect(() => {
        if (IsOpenedFromConversionBar) {
            trackDynamicCTAClick(trackingService, buttonInfo.label, selectedModality);
            openDialog();
        }
    }, [IsOpenedFromConversionBar]);
    const postDataFSCheckout = () => {
        let postCheckoutData;
        if (typeof document !== 'undefined') {
            try {
                const isCashCheckout = buttonInfo.type === 'cash-checkout';
                postCheckoutData = useRethinkFSCheckoutPostData(vehicle, buttonInfo.dataProfile, vehicle.countryCode, vehicle.langCode, scContextId, useFinanceData, isCashCheckout);
            }
            catch (error) {
                logger === null || logger === void 0 ? void 0 : logger.error('Error fetching postCheckoutData:', error);
            }
        }
        return postCheckoutData;
    };
    const fsOnBtnClick = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsApiInprogress(true);
            const postData = yield postDataFSCheckout();
            const fsLink = yield fsCheckoutPostRequest(buttonInfo.url, postData);
            setFsCheckoutLink(fsLink);
        }
        catch (_a) {
            setFsCheckoutLink(buttonInfo.notFoundPageUrl);
        }
        setIsApiInprogress(false);
    });
    const openDialog = () => {
        setIsDialogOpen(true);
        fsOnBtnClick();
    };
    const closeDialog = () => {
        setIsDialogOpen(false);
        if (IsOpenedFromConversionBar) {
            setIsOpenedFromConversionBar(false);
            onClickToCloseFSPopup();
        }
    };
    return (React.createElement(React.Fragment, { key: buttonInfo.type },
        React.createElement(Dialog, { "aria-label": financeCheckoutTranslations.financeCheckoutOuterLayer, onCloseButtonAriaLabel: financeCheckoutTranslations.financeCheckoutAriaCloseBtn, hasCloseButton: true, variant: "focus-large", open: isDialogOpen, onClose: closeDialog },
            React.createElement(FinanceCheckoutLayer, { buttonInfo: buttonInfo, trackButtonClick: trackButtonClick, isApiInprogress: isApiInprogress, closeFocusLayer: closeDialog, fsCheckoutLink: fsCheckoutLink, modifiedProductID: modifiedProductID, vehicleType: vehicleType })),
        !isRenderedInConversionBar && (React.createElement(StyledButton, { onClick: () => {
                openDialog();
                trackDynamicCTAClick(trackingService, buttonInfo.label, selectedModality);
            }, variant: variant, "data-tracking-exclude": true, isFullWidth: isMobileScreenSize, isLoading: isLoading, "data-testid": "finance-checkout", "aria-label": financeCheckoutTranslations.financeCheckoutAriaBtn, size: dynamicStylingHelper('md', 'sm') }, buttonInfo.label))));
};
const StyledButton = styled((props) => React.createElement(TextButton, Object.assign({}, props))) `
  @media (max-width: 479px) {
    width: 100%;
  }
`;
